/**
 * ==========================================
 * 应用统一配置中心
 * ==========================================
 * 从环境变量读取配置，确保开发和生产环境的一致性
 */

const isDev = process.env.NODE_ENV === 'development'

const config = {
  // ==========================================
  // 基础信息
  // ==========================================
  env: process.env.NODE_ENV || 'development',
  appName: process.env.VUE_APP_NAME || 'ACS-Conference',
  version: process.env.VUE_APP_VERSION || '1.0.0',
  debug: process.env.VUE_APP_DEBUG === 'true',
  
  // ==========================================
  // API 配置
  // ==========================================
  
  /**
   * API 基础地址
   * 开发环境使用相对路径 /api (通过代理转发)
   * 生产环境使用完整 URL
   */
  baseUrl: isDev 
    ? '/api' 
    : (process.env.VUE_APP_BASE_API || 'https://www.criminology.asia/cas-pay'),
  
  /**
   * 后端服务地址 (用于代理配置)
   */
  apiHost: process.env.VUE_APP_API_HOST || 'http://localhost:7481',
  
  /**
   * WebSocket 地址
   */
  socketUrl: process.env.VUE_APP_SOCKET_URL || 'ws://localhost:7481/ws',
  
  // ==========================================
  // 文件服务配置
  // ==========================================
  
  /**
   * 文件服务基础地址
   * 用于文件下载、预览等
   */
  fileUrl: isDev
    ? '/api'
    : (process.env.VUE_APP_FILE_URL || 'https://www.criminology.asia/cas-pay'),
  
  /**
   * 文件上传接口完整地址
   */
  uploadUrl: isDev
    ? `/api${process.env.VUE_APP_UPLOAD_PATH || '/cas-sys-media/media/upload/uploadFile'}`
    : `${process.env.VUE_APP_FILE_URL || 'https://www.criminology.asia/cas-pay'}${process.env.VUE_APP_UPLOAD_PATH || '/cas-sys-media/media/upload/uploadFile'}`,
  
  /**
   * 上传路径 (不含域名)
   */
  uploadPath: process.env.VUE_APP_UPLOAD_PATH || '/cas-sys-media/media/upload/uploadFile',
  
  // ==========================================
  // 渠道认证配置
  // ==========================================
  cuserchannel: process.env.VUE_APP_CUSER_CHANNEL || 'CAS100PCWEBC002',
  buserchannel: process.env.VUE_APP_BUSER_CHANNEL || 'CAS100PCWEBB001',
  CAPP_SECRET: process.env.VUE_APP_CAPP_SECRET || 'G8nX__2i3hx_Uy813AidWsZd9av2IcXLK46hS34Adcg',
  BAPP_SECRET: process.env.VUE_APP_BAPP_SECRET || 'G8nX__2i3hx_Uy813AidWsZd9av2IcXLK46hS34Adcg',
  
  // ==========================================
  // 功能开关
  // ==========================================
  enableMock: process.env.VUE_APP_ENABLE_MOCK === 'true',
}

// ==========================================
// 配置验证
// ==========================================
if (config.debug) {
  console.log('[Config] Environment:', config.env)
  console.log('[Config] Base URL:', config.baseUrl)
  console.log('[Config] API Host:', config.apiHost)
  console.log('[Config] Upload URL:', config.uploadUrl)
}

export default config
